import { render, staticRenderFns } from "./ERP_exchange_access-modal.vue?vue&type=template&id=1ac7e794&scoped=true"
import script from "./ERP_exchange_access-modal.vue?vue&type=script&lang=js"
export * from "./ERP_exchange_access-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7e794",
  null
  
)

export default component.exports